<ng-container *ngIf="!showFallback; else fallbackTemplate">
  <ng-container *ngIf="!!full">{{ full }} full</ng-container>
  <ng-container *ngIf="!!full && !!half">, </ng-container>
  <ng-container *ngIf="!!half">{{ half }} half</ng-container>
</ng-container>

<ng-template #fallbackTemplate>{{ fallback }}</ng-template>
